import { render, staticRenderFns } from "./logisTransAccount.vue?vue&type=template&id=7c2ef389&scoped=true&"
import script from "./logisTransAccount.vue?vue&type=script&lang=js&"
export * from "./logisTransAccount.vue?vue&type=script&lang=js&"
import style0 from "./logisTransAccount.vue?vue&type=style&index=0&id=7c2ef389&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2ef389",
  null
  
)

component.options.__file = "logisTransAccount.vue"
export default component.exports